import React, { useEffect, useState } from "react";
import { IUserLogin } from "../interfaces/User";
import { useDispatch, useSelector } from "react-redux";
import { getSetup, loginUser, logout, sendConfirm, sendPass } from "../services/apiService";
import { checkRights } from "../core/Helper";
import { setAvatar, setMessage, setSubTitle } from "../stores/AppReducer";
import { useNavigate } from "react-router-dom";
import CustomCheckBox from "./CustomCheckBox";
import type { AppDispatch, IApplicationState } from "../stores/AppStore";
import CustomInputValidity from "./CustomInputValidity";
import { MessageType } from "../interfaces/App";

enum SecondFactor {
    sms,
    mail
}

function Login() {
    const navigate = useNavigate();
    const initialState: IUserLogin = { user: "", passwd: "", email: "", sms: "" };
    const app = useSelector((appState: IApplicationState) => appState.app);
    const [state, setState] = useState(initialState);
    const [reset, setReset] = useState(false);
    const [secondFactor, setSecondFactor] = useState(SecondFactor.sms);

    const dispatch = useDispatch<AppDispatch>();

    useEffect(() => {
        dispatch(setSubTitle(app.loggedIn ? "Profile" : "Login"));
        setState({...initialState, sms: app.user.phone, email: app.user.email})
    }, []);

    const becomeAvatar = () => {
        if (app.loggedIn && checkRights(app.user)) {
            dispatch(setAvatar(true));
        }
    };
    const handleLogin = (ev: any) => {
        ev.preventDefault();
        dispatch(loginUser(state)).then((res: any) => {
            if (res.type === "put/login/fulfilled") {
                dispatch(getSetup(null));
            }
        });
    };
    const handleReset = (ev: any) => {
        ev.preventDefault();
        dispatch(sendPass({ user: state.user })).then((res: any) => {
            if (res.type === "get/sendPass/fulfilled") {
                dispatch(setMessage({ msg: res.payload.data, type: MessageType.success }));
                setReset(false);
            }
        });
    };
    const handleCompleteProfile = (ev: any) => {
        ev.preventDefault();
        const send = secondFactor === SecondFactor.sms ? { sms: state.sms } : { email: state.user };
        dispatch(sendConfirm(send)).then((res: any) => {
            if (res.type === "get/sendConfirm/fulfilled") {
                dispatch(setMessage({ msg: res.payload.data.msg, type: MessageType.success }));
                navigate(secondFactor === SecondFactor.sms ? "/profile/:smscode" : "/profile/:emailcode");
            } else {
                dispatch(setMessage({ msg: res.error.message, type: MessageType.error }));
            }
        });
    };
    const handleLogout = () => {
        dispatch(logout({ token: "none" }));
    };

    const renderLogin = () => {
        return (
            <form onSubmit={(ev: any) => handleLogin(ev)} >
                <div className="loginBox">
                    {/* <input 
                        value={state.user}
                        placeholder="Login"
                        onChange={(ev) => setState({...state, user: ev.currentTarget.value})}
                    /> 
                    <input type="password" placeholder="Kennwort" value={state.passwd} onChange={(ev) => setState({...state, passwd: ev.currentTarget.value})}  />
                    */}
                    <CustomInputValidity
                        id={"user"}
                        value={state.user}
                        label="Login"
                        setState={(_name, user) => setState({ ...state, user })}
                        className={"custom_input"}
                    />
                    <CustomInputValidity
                        id={"pass"}
                        type={"password"}
                        value={state.passwd}
                        label="Password"
                        additional={"eye"}
                        setState={(_name, passwd) => setState({ ...state, passwd })}
                        className={"custom_input"}
                    />
                    <input type="submit" className="animButton" value="Ok" />
                    <div onClick={() => navigate("/authlink")} className="like_a_link">Du hast einen Digitalen-Schlüssel bekommen?</div>
                    <div onClick={() => setReset(true)} className="like_a_link">Ich habe mein Passwort vergessen.</div>
                    <div className="clear" />
                </div>
            </form>
        );
    };
    const renderReset = () => {
        return (
            <form onSubmit={(ev: any) => handleReset(ev)} >
                <div className="loginBox">
                    {/* <input 
                        value={state.user}
                        placeholder="Email Adresse"
                        onChange={(ev) => setState({...state, user: ev.target.value})}
                    /> */}
                    <CustomInputValidity
                        id={"user"}
                        value={state.user}
                        label="Email Adresse"
                        setState={(_name, user) => setState({ ...state, user })}
                        className={"custom_input"}
                    />
                    <input type="submit" className="animButton" value="Sende Passwort Reset E-Mail" />
                    <div className="clear" />
                    <div onClick={() => setReset(false)} className="like_a_link">Zum Login</div>
                </div>
            </form>
        );
    };
    const renderFormEmail = () => {
        return (
            <>
                <label htmlFor={'user'}>Deine E-Mail</label>
                <input
                    id={'user'}
                    value={state.user}
                    placeholder="E-Mail"
                    onChange={(ev) => setState({ ...state, user: ev.target.value })}
                    autoComplete="off"
                />
                <input type="submit" className="animButton" value="E-Mail senden" />
            </>
        );
    };
    const renderFormSMS = () => {
        return (
            <>
                <label htmlFor={'user'}>Deine Mobil-Telefonnummer</label>
                <input
                    id={'sms'}
                    value={state.sms}
                    placeholder="mobile Telefonnnumer: 0049..."
                    onChange={(ev) => setState({ ...state, sms: ev.currentTarget.value })}
                    autoComplete="off"
                />
                <input type="submit" className="animButton" value="SMS senden" />
            </>
        );
    };
    const renderCompleteProfile = () => {
        return (
            <div>
                <p>Du darfst hier nur lesen.</p>
                <p>Indentifiziere Dich, indem Du Deine Email-Adresse oder Telefonnummer eingibst und bestätigst.</p>
                <p>Dann kannst Du auch eigene Inhalte erstellen.</p>
                <div>

                    <CustomCheckBox
                        label={"SMS oder Email"}
                        value={secondFactor === SecondFactor.sms}
                        switch={() => setSecondFactor(secondFactor === SecondFactor.sms ? SecondFactor.mail : SecondFactor.sms)}
                    />
                    <form onSubmit={(ev) => handleCompleteProfile(ev)} >
                        {secondFactor === SecondFactor.sms && renderFormSMS()}
                        {secondFactor === SecondFactor.mail && renderFormEmail()}
                        <div className="clear" />
                    </form>
                </div>
            </div>
        );
    };
    const renderLogout = () => {
        return (
            <div className="loginBox clear">
                <button onClick={() => handleLogout()} className="animButton">Logout</button>
                {checkRights(app.user) && renderGotAvatar()}
                <br />
                {app.user.readonly
                    ? renderCompleteProfile()
                    : <div onClick={() => navigate("/profile/:pass")} className="like_a_link">Passwort ändern</div>
                }
                {app.user.hasToken && !app.user.readonly
                    && <div onClick={() => navigate("/newToken")} className="like_a_link">Token erneuern</div>
                }
                {app.loggedIn && !app.user.readonly
                    && <div onClick={() => navigate("/profile/:all")} className="like_a_link">Benutzerdaten und Einstellungen</div>
                }
            </div>
        );
    };

    const renderGotAvatar = () => {
        return app.loggedIn && false
            ? (
                <button onClick={() => becomeAvatar()} className="animButton">Avatar</button>
            ) : (null);
    };
    return (
        <div>
            {app.loggedIn ? renderLogout() : reset ? renderReset() : renderLogin()}
        </div>
    );
}

export default (Login);

